const saveNavState = expanded => {
    localStorage.setItem('navExpanded', expanded);
};

const getNavState = () => {
    return localStorage.getItem('navExpanded');
};

const clearNavState = () => {
    localStorage.removeItem('navExpanded');
};

export {
    saveNavState,
    getNavState,
    clearNavState,
};

